import { UserManager, WebStorageStateStore, Log } from 'oidc-client';
import { getRememberMeCookie } from 'helpers/cookies';

Log.logger = console;
// For more configuration see: https://github.com/IdentityModel/oidc-client-js/wiki#logging
Log.level = process.env.NODE_ENV !== 'production' ? Log.ERROR : Log.NONE;

export default class SecurityService {
  constructor() {
    // For more configurations see: https://github.com/IdentityModel/oidc-client-js/wiki#usermanager
    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: process.env.OIDC_AUTHORITY,
      client_id: process.env.OIDC_CLIENT_ID,
      redirect_uri: process.env.OIDC_REDIRECT_URI,
      response_type: process.env.OIDC_RESPONSE_TYPE,
      scope: process.env.OIDC_SCOPE,
      post_logout_redirect_uri: process.env.OIDC_POST_LOGOUT_REDIRECT_URI,
      filterProtocolClaims: true
    };

    this.userManager = new UserManager(settings);

    // UserManager Events
    this.userManager.events.addAccessTokenExpired(() => {
      const rememberMe = getRememberMeCookie();
      if (rememberMe) {
        this.userManager
          .removeUser()
          .then(() => {
            this.userManager.signinRedirect({ login_hint: rememberMe });
          })
          .catch(err => {
            console.log(err);
            this.userManager.signoutRedirect();
          });
      } else {
        this.userManager.signoutRedirect();
      }
    });
  }

  getUser() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user))
        .catch(err => reject(err));
    });
  }

  getSignedIn() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => {
          resolve(user !== null && !user.expired);
        })
        .catch(err => reject(err));
    });
  }

  signinRedirectCallback() {
    return new Promise((resolve, reject) => {
      this.userManager
        .signinRedirectCallback()
        .then(user => {
          const resolveObj = { sucess: user !== null };
          if (resolveObj.sucess) resolveObj.state = user.state;
          resolve(resolveObj);
        })
        .catch(err => reject(err));
    });
  }

  /* eslint-disable-next-line camelcase */
  signIn(login_hint, state, acr_values) {
    return new Promise((resolve, reject) => {
      this.userManager
        .signinRedirect({ login_hint, state, acr_values })
        .then(user => resolve(user !== null))
        .catch(err => reject(err));
    });
  }

  signOut() {
    this.userManager.signoutRedirect();
  }

  getToken() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user !== null ? user : false))
        .catch(err => reject(err));
    });
  }

  getProfile() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user !== null ? user.profile : false))
        .catch(err => reject(err));
    });
  }

  getIdToken() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user !== null ? user.id_token : false))
        .catch(err => reject(err));
    });
  }

  getSessionState() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user !== null ? user.session_state : false))
        .catch(err => reject(err));
    });
  }

  getAcessTokenAndType() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user =>
          resolve(
            user !== null ? { token_type: user.token_type, access_token: user.access_token } : false
          )
        )
        .catch(err => reject(err));
    });
  }

  getScopes() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => resolve(user !== null ? user.scopes : false))
        .catch(err => reject(err));
    });
  }

  getRole() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then(user => {
          if (user !== null && user.profile) {
            const { role } = user.profile;
            resolve(typeof role === 'string' ? [role] : role);
          } else {
            resolve(false);
          }
        })
        .catch(err => reject(err));
    });
  }
}
